import React from 'react'
import { StoreView } from 'resources/constants'

let App = () => <div />

if (process.env.REACT_APP_MAGENTO_STORE_VIEW === StoreView.LivBrite) {
  // eslint-disable-next-line
  App = require('./livbrite').Index
}

if (process.env.REACT_APP_MAGENTO_STORE_VIEW === StoreView.SofiaAndGrace) {
  // eslint-disable-next-line
  App = require('./sofia').Index
}

export {
  App
}
